import { useEffect, useState } from 'react'

import { useIsMounted } from 'shared/hooks'
import { isEmpty } from 'shared/utils/isEmpty'

export const useHeaderNotificationsBell = (newNotification: any) => {
  const [isAnimatedBell, setAnimatedBell] = useState<boolean>(false)

  const { isMounted } = useIsMounted()

  useEffect(() => {
    if (!isEmpty(newNotification) && isMounted) {
      setAnimatedBell(true)

      setTimeout(() => {
        setAnimatedBell(false)
      }, 2000)
    }
  }, [isMounted, newNotification])

  return {
    isAnimatedBell
  }
}
